<template>
  <div class="ai-chips">
    <button
      v-for="(item, idx) in items"
      :key="idx"
      type="button"
      class="chip"
      :class="{ clickable: interactive }"
      :disabled="!interactive"
      @click="$emit('send', item)"
    >
      {{ item }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'AiChipsBlock',
  props: {
    block: { type: Object, required: true },
    interactive: { type: Boolean, default: false },
  },
  computed: {
    items() {
      return this.block.items || [];
    },
  },
};
</script>

<style scoped>
.ai-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.chip {
  border: 1px solid #d1d5db;
  border-radius: 16px;
  background: #fff;
  color: #374151;
  font-size: 12px;
  padding: 3px 12px;
}

.chip.clickable {
  cursor: pointer;
}

.chip.clickable:hover {
  background: #eff6ff;
  border-color: #2563eb;
  color: #2563eb;
}

.chip:disabled {
  cursor: default;
  color: #6b7280;
}
</style>
